export const SUPPORT_LINKS = {
  TG: 'https://t.me/alivewaternewbot',
  MAX: 'https://max.ru/id5904350960_1_bot',
  Tell: null
};
